import {app} from '../../app';
import {RadioQuestionComponent} from "./RadioQuestionComponent";
import {LikertScaleSharedQuestion} from "../../sharedQuestions/LikertScaleSharedQuestion";

export class LikertScaleQuestionComponent extends RadioQuestionComponent {

    $onInit = () => {
        this.choices = [
            'strongly_disagree',
            'disagree',
            'in_between',
            'agree',
            'strongly_agree',
        ];

        this.style = 'buttons';

        this.sharedQuestion = new LikertScaleSharedQuestion();

        super.setup();
    };

}

app.component('likertScaleQuestion', {
    templateUrl : 'templates/components/questionTypes/radioQuestion.html',
    controller  : LikertScaleQuestionComponent,
    controllerAs: 'radioQuestion',
    bindings    : {
        question            : '<',
        nextQuestionCallback: '&',
        preventNextQuestion : '@'
    }
});